import { isMultisigFeatureEnabled, MultisigFeatureFlag } from "@/constants/multisigFeatureFlags";

export const useIsMultisigFeatureEnabled = (flag: MultisigFeatureFlag): boolean => {
  return isMultisigFeatureEnabled(flag);
};
